import { dialog } from "../../../nq-component";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { findObjectUseCase } from "../../../usecases/object";
import { use } from "react";
import { set } from "date-fns";

function DialogAssignCoordinator({
  handleClientValue,
  handleLocationValue,
  coordinators,
  submit,
  handleCoordinatorChange,
  locations,
  clients,
}) {
  const [_coordinators, _setCoordinators] = useState([]);
  const [_locations, _setLocations] = useState([]);
  const [client, setClient] = useState("");
  const [location, setLocation] = useState("");
  const [coordinator, setCoordinator] = useState("");

  console.log("locloc", location);

  const getCoordinators = useCallback(async () => {
    if (!location) return;
    if (!client) return;

    try {
      const query = {
        where: {
          "location.id": location,
          "clients.id": { $in: [client] },
          "roles.id": "Coordinator",
        },
        include: ["all", "location", "employees"],
      };
      const response = await findObjectUseCase().execute("users", query);
      _setCoordinators(response || []);
    } catch (error) {
      console.error("Error fetching coordinators:", error);
    }
  }, [location, client]);

  const getLocations = useCallback(async () => {
    if (!client) return;

    try {
      const query = {
        where: { "clients.id": { $in: [client] } },
        include: ["all", "location", "employees"],
      };
      const response = await findObjectUseCase().execute("locations", query);
      _setLocations(response || []);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, [client]);

  useEffect(() => {
    getCoordinators();
  }, [getCoordinators]);

  useEffect(() => {
    getLocations();
  }, [getLocations]);

  const handleClientChange = (e) => {
    setClient(e.target.value);
    handleClientValue(e);
    setLocation("");
    setCoordinator("");
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
    handleLocationValue(e);
    setCoordinator("");
  };

  const _handleCoordinatorChange = (e) => {
    setCoordinator(e.target.value);
    handleCoordinatorChange(e);
  };

  const coordinatorOptions = useMemo(
    () =>
      _coordinators.map((coordinator) => (
        <option key={coordinator.id} value={coordinator.id}>
          {[
            coordinator.employee?.firstName,
            coordinator.employee?.middleName,
            coordinator.employee?.lastName,
          ]
            .filter(Boolean)
            .join(" ")}
        </option>
      )),
    [_coordinators]
  );

  const onSubmit = (e) => {
    e.preventDefault();
    submit();
  };

  console.log("coor", _coordinators);
  return (
    <form onSubmit={onSubmit}>
      <div className="p-4">
        <div className="d-flex flex-column align-items-center gap-3">
          <div className="d-flex align-self-start align-items-center gap-2">
            <i
              className="bi bi-person-circle fs-2 px-2 rounded"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
            <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
              Assign Coordinator
            </h5>
          </div>

          <div className="container-fluid px-4">
            <div className="ms-2 me-1">
              <label className="mt-4 fw-medium mb-1">
                Select Client<span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-control bg-light-subtle p-2"
                onChange={handleClientChange}
                value={client}
                required
              >
                <option value="" disabled>
                  Select
                </option>

                {Array.isArray(clients) && clients.length > 0 ? (
                  clients.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No clients available</option>
                )}
              </select>
            </div>

            <div className="ms-2 me-1">
              <label className="mt-4 fw-medium mb-1">
                Select Area<span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-control bg-light-subtle p-2"
                onChange={handleLocationChange}
                value={location}
                required
              >
                <option value="" disabled>
                  Select
                </option>

                {_locations && _locations.length > 0 ? (
                  _locations.map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No locations available</option>
                )}
              </select>
            </div>

            <div className="ms-2 me-1">
              <label className="mt-4 fw-medium mb-1">
                Select Coordinator<span className="text-danger ms-1">*</span>
              </label>
              <select
                className="form-control bg-light-subtle p-2"
                onChange={_handleCoordinatorChange}
                value={coordinator}
                required
              >
                <option value="" disabled>
                  Select
                </option>

                {_coordinators && _coordinators.length > 0 ? (
                  coordinatorOptions
                ) : (
                  <option disabled>No coordinators available</option>
                )}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mb-3">
        <button
          type="button"
          className="btn"
          style={{ backgroundColor: "#e8ecf3" }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn text-white ms-2"
          style={{ backgroundColor: "#D18237" }}
          // onClick={submit}
        >
          Submit
        </button>
      </div>
    </form>
  );
}

export default DialogAssignCoordinator;
